import React from "react"
import "../../styles/Common/CircleIcon.less"
import Image from "./Image"

const CircleIcon = ({ iconStyle = "DefaultCircleIcon", onClick, iconUrl, imgheight, imgwidth, imgalt, ...props }) => {
  return <Image className={iconStyle} alt={imgalt ? imgalt : `${iconUrl}`} src={iconUrl} onClick={onClick} width={imgwidth ? imgwidth : ""} height={imgheight ? imgheight : ""} />
}

export default CircleIcon
